import CnsProcedureLobbyView from 'CnsProcedureLobby/views/CnsProcedureLobbyView';

export default CnsProcedureLobbyView;
